import { render } from "./DefScrollTo.vue?vue&type=template&id=51abfb0f&scoped=true"
import script from "./DefScrollTo.vue?vue&type=script&lang=js"
export * from "./DefScrollTo.vue?vue&type=script&lang=js"

import "./DefScrollTo.vue?vue&type=style&index=0&id=51abfb0f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51abfb0f"]])

export default __exports__